const firebaseConfig = {
    apiKey: "AIzaSyB-bVozgN1P1pjKhfNgh-cDfGiuGbY9mgE",
    authDomain: "ama-cuadro.firebaseapp.com",
    projectId: "ama-cuadro",
    storageBucket: "ama-cuadro.appspot.com",
    messagingSenderId: "121225538329",
    appId: "1:121225538329:web:7f7967fd10a4ddddd37388"
};

export default firebaseConfig;